// Helpers de presentación de texto. Solo cambian cómo se MUESTRA un dato, nunca lo
// que se guarda o se envía a la API.

const MINUSCULAS = new Set(['de', 'del', 'la', 'las', 'los', 'y', 'e', 'da', 'van', 'von']);

const capitalizar = (p) => p.charAt(0).toUpperCase() + p.slice(1);

/**
 * "adriana saez" → "Adriana Saez"; "Braulio bustos aviles" → "Braulio Bustos Aviles";
 * "ACTIVIDADES INACTIVAS" → "Actividades Inactivas".
 * Palabra por palabra: se capitaliza la que viene entera en minúscula. Si TODO el
 * texto está en mayúsculas se pasa a formato título; si no, las palabras en
 * mayúscula se respetan (siglas como "UMCE").
 */
export const formatearNombre = (texto) => {
    if (!texto || typeof texto !== 'string') return texto;
    const t = texto.trim();
    const todoMayus = t === t.toUpperCase() && t !== t.toLowerCase();
    return t.split(/(\s+)/).map((p, i) => {
        const base = todoMayus ? p.toLowerCase() : p;
        if (base !== base.toLowerCase()) return base; // ya trae mayúsculas: se respeta
        return (i > 0 && MINUSCULAS.has(base)) ? base : capitalizar(base);
    }).join('');
};
